import React from 'react';
interface UnleashFeatureToggleProps {
  activeFeature: 'angel' | 'scenario';
  onToggle: (feature: 'angel' | 'scenario') => void;
}
export const UnleashFeatureToggle: React.FC<UnleashFeatureToggleProps> = ({
  activeFeature,
  onToggle
}) => {
  return <div className="flex justify-center mb-6" data-id="element-22335">
      <div className="bg-gray-100 dark:bg-gray-800 rounded-full p-1 flex" data-id="element-22336">
        <button className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${activeFeature === 'angel' ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white shadow-md' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => onToggle('angel')} data-id="element-22337">
          Personal Angel
        </button>
        <button className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${activeFeature === 'scenario' ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white shadow-md' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => onToggle('scenario')} data-id="element-22338">
          Personal Fantasy
        </button>
      </div>
    </div>;
};